import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useAiRating } from "hooks";
import { RATINGS } from "constants/index";
import ThumbsUp from "assets/images/thumbs_up.svg";
import ThumbsUpFilled from "assets/images/thumbs_up_filled.svg";
import ThumbsDown from "assets/images/thumbs_down.svg";
import ThumbsDownFilled from "assets/images/thumbs_down_filled.svg";
import { RatingButtons } from "components/Form";

/**
 * AiRating
 *
 * @param {String}   text
 * @param {String}   resourceType
 * @param {String}   resourceId
 * @param {String}   contentType
 * @param {String}   contentHash
 */
const AiRating = ({ text, resourceType, resourceId, contentType, contentHash, ...props }) => {
  const [rating, setRating] = useState();
  const { handleAddAiRating } = useAiRating();

  const thumbsUpIcon = rating === RATINGS.positive ? ThumbsUpFilled : ThumbsUp;
  const thumbsDownIcon = rating === RATINGS.negative ? ThumbsDownFilled : ThumbsDown;

  const handleRating = (_name, rating) => {
    handleAddAiRating(
      {
        rating,
        contentHash,
        contentType,
        resourceType,
        resourceId,
      },
      () => setRating(rating)
    );
  };

  return (
    <RatingButtons
      name="aiRating"
      label={text}
      onChange={handleRating}
      thumbsUpIcon={thumbsUpIcon}
      thumbsDownIcon={thumbsDownIcon}
      disabled={!!rating}
      {...props}
    />
  );
};

AiRating.defaultProps = {
  text: <FormattedMessage id="Profile.ProfileVideoInterviewsList.RateTranscript" />,
};

AiRating.propTypes = {
  resourceType: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  contentHash: PropTypes.string.isRequired,
  text: PropTypes.element,
};

export default AiRating;
